/**
 * The one way the app names a channel's visibility, in the words of the
 * choices on the channel's Access sheet.
 */
export function channelVisibilityLabel(
  visibility: "private" | "shared" | undefined,
  options: { compact?: boolean } = {},
): string {
  if (visibility === "private") return "Invite only";
  // A table cell has room for one word.
  return options.compact ? "Organisation" : "Everyone in your organisation";
}
